var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDishImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#dbdbdb",
    viewBox: "0 -24.48 122.88 122.88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    stroke: "#dbdbdb",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.31 36.95c0 9.92-3.49 18.39-10.48 25.38q-10.5 10.5-25.38 10.5c-9.88 0-18.34-3.49-25.35-10.5-7-6.99-10.52-15.46-10.52-25.38 0-9.89 3.51-18.32 10.52-25.34 7.03-7 15.48-10.52 25.35-10.52 9.92 0 18.38 3.51 25.38 10.52 6.98 7.02 10.48 15.45 10.48 25.34zm-80.94-6.61c3.15-2.15 4.73-4.96 4.46-11.39V2.42c-.03-2.31-4.22-2.59-4.43 0l-.16 13.41c-.01 2.51-3.78 2.59-3.77 0l.16-13.87c-.05-2.48-4.05-2.73-4.1 0 0 3.85-.16 10.02-.16 13.87.2 2.43-3.3 2.75-3.21 0l.16-13.78C5.23.18 3.17-.49 1.77.39.28 1.34.58 3.25.52 4.86L0 20.68c.08 4.6 1.29 8.34 4.89 9.93.55.24 1.31.43 2.19.56L5.84 69.75c-.07 2.29 1.8 4.16 3.99 4.16h.5c2.47 0 4.56-2.11 4.49-4.68l-1.09-38.07c1.15-.18 2.1-.45 2.64-.82zm90.37 38.25-.06-34.65C94.53 26.92 98.4-.13 110.56.02c14.78.17 16.53 30.48 3.82 33.81l.94 34.9c.18 6.6-8.57 7.21-8.58-.14zM82.33 36.92c0 5.78-2.03 10.71-6.12 14.8-4.08 4.07-9.01 6.12-14.79 6.12-5.74 0-10.67-2.05-14.75-6.12-4.08-4.09-6.12-9.02-6.12-14.8 0-5.74 2.04-10.67 6.12-14.74 4.09-4.07 9.01-6.12 14.75-6.12 11.61.01 20.91 9.24 20.91 20.86zm4.89 0c0-7.1-2.5-13.17-7.53-18.2s-11.12-7.53-18.27-7.53c-7.13 0-13.2 2.5-18.2 7.53-5.03 5.03-7.56 11.1-7.56 18.2 0 7.12 2.53 13.19 7.56 18.24 5 5.04 11.07 7.57 18.2 7.57 7.14 0 13.23-2.53 18.27-7.57 5.02-5.06 7.53-11.13 7.53-18.24z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDishImage);
export default __webpack_public_path__ + "static/media/NoDishImage.0aaf274bd37668eabd99924017258ffb.svg";
export { ForwardRef as ReactComponent };